// Shared react-select theming for the client request forms, so every dropdown
// uses the coral brand instead of react-select's default blue (#2684FF) for
// focus rings, hovered options and the selected option.

export const CORAL = '#ff5a60';
const CORAL_DARK = '#f0454c';
const CORAL_SOFT = '#fff1f2';
const CORAL_SOFT_2 = '#ffe4e6';

// Recolors react-select's internal palette (focus border, option hover/active).
export const coralSelectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
        ...theme.colors,
        primary: CORAL,        // focused control border + selected option bg
        primary75: CORAL_DARK,
        primary50: CORAL_SOFT_2, // option :active bg
        primary25: CORAL_SOFT,   // option hover bg
    },
});

// Layout + focus-ring styles matching the coral inputs (12px radius, 44px tall,
// soft coral focus glow). menuPortal keeps the dropdown above the modal.
export const coralSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderRadius: 12,
        minHeight: 44,
        borderColor: state.isFocused ? CORAL : '#e2e2e2',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(255, 90, 96, 0.14)' : 'none',
        '&:hover': { borderColor: CORAL },
        fontSize: 14,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? CORAL : state.isFocused ? CORAL_SOFT : '#fff',
        color: state.isSelected ? '#fff' : '#111827',
        fontSize: 14,
        cursor: 'pointer',
        ':active': { backgroundColor: state.isSelected ? CORAL : CORAL_SOFT_2 },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 1200 }),
};
